function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { useLayoutEffect } from 'react';
import clsx from 'clsx';
import { PureComponent } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ToastType } from 'common/components/toast/types';
import { addToast } from 'common/components/toast-area/toast-manager';
import { assertUnreachable } from 'common/util/typescript';
import { useDashboardSelectorController } from 'common/contexts/react/dashboard-selector-controller-context';
import { DashboardsContext } from '../util/context';
import '../stylesheets/index.styl';
import { AppMode } from '../models/enums';
import './digest-mode.styl';
import { DownloadMode } from './download-mode';
import { ManageDigestsMode } from './manage-digests-mode';
import { DigestModeReact } from './digest-mode';
import { StandardMode } from './standard-mode';
type Props = {
  context: DashboardsContext;
};
function ModeContainer(props: {
  context: DashboardsContext;
  onToast(ev: CustomEvent): void;
}) {
  const context = props.context;
  const onToast = props.onToast;
  const selectorController = useDashboardSelectorController();
  const location = useLocation();
  if (context && selectorController) {
    // explicit declare different modes here.
    switch (context.appMode) {
      // TODO: remove digest mode after SPA is live
      case AppMode.Digest:
        return <DigestModeReact props={{
          location,
          context,
          selectorController
        }} />;
      case AppMode.Standard:
        return <StandardMode elref='standardMode' context={context} onToast={onToast} />;
      // TODO: directly consume useSearchParams to render DownloadMode
      case AppMode.Download:
        return <DownloadMode elref='downloadMode' context={context} />;
      default:
        assertUnreachable(context.appMode);
    }
  }
  return null;
}
class DashboardsAppClass extends PureComponent<Props> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleToast", ev => {
      this.createToast(ev.detail, ev.detail.timeoutMS);
    });
  }
  // Toast Helpers
  createToast() {
    let {
      text = null,
      type = ToastType.INFO,
      report = null,
      undo = null,
      cta = null,
      ctaCallback = null
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let timeoutMS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const newToast = {
      report,
      message: text,
      timeout: timeoutMS,
      type,
      undoable: !!undo,
      undoCallback: undo,
      cta,
      ctaCallback
    };
    addToast(newToast);
  }
  render() {
    return <div elref='dashboardsApp' className={clsx("dashboards-app", "inherit-size")} data-sentry-component="DashboardsAppClass" data-sentry-source-file="index.tsx">
        <Routes data-sentry-element="Routes" data-sentry-source-file="index.tsx">
          <Route path='subscriptions' element={<ManageDigestsMode context={this.props.context} onToast={this.handleToast} />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
          <Route path='*' element={<ModeContainer context={this.props.context} onToast={this.handleToast} />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        </Routes>
      </div>;
  }
}
export type { DashboardsAppClass };
export const DashboardsApp = React.forwardRef<DashboardsAppClass, Props>((props, ref) => {
  const [searchParams] = useSearchParams();
  const isManageDigestSearchParams = searchParams.get("manage-digests");
  const navigate = useNavigate();
  useLayoutEffect(() => {
    if (isManageDigestSearchParams) {
      navigate("subscriptions");
    }
  }, [navigate, isManageDigestSearchParams]);
  return <DashboardsAppClass ref={ref} {...props} />;
});